import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const objectListFlyoutEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_async-object-list-flyout-entrypoint" */ './index'
			),
		{
			moduleId: 'objectListFlyoutEntrypoint',
		},
	),
	getPreloadProps: () => ({}),
});
